import { AxiosError } from 'axios';

import { setMaintenanceActive } from '@/contexts/maintenance/Maintenance.context.ts';

import { HTTP_STATUS } from './ErrorCode.model';
import { HTTP_HEADER } from './httpHeaders.model';

type MaintenanceResponseBody = {
  maintenanceEndDate?: string;
  maintenanceMode?: boolean;
  messageEn?: string;
  messagePl?: string;
};

const isMaintenanceResponse = (error: AxiosError<MaintenanceResponseBody>): boolean => {
  const response = error.response;
  if (!response || response.status !== HTTP_STATUS.SERVICE_UNAVAILABLE) {
    return false;
  }
  const headerValue = response.headers?.[HTTP_HEADER['X-Maintenance-Mode'].toLowerCase()];
  return headerValue === 'true' || response.data?.maintenanceMode === true;
};

export const maintenanceErrorInterceptor = (error: unknown): Promise<never> => {
  const axiosError = error as AxiosError<MaintenanceResponseBody>;
  if (isMaintenanceResponse(axiosError)) {
    const data = axiosError.response?.data;
    setMaintenanceActive({
      maintenanceEndDate: data?.maintenanceEndDate,
      messageEn: data?.messageEn,
      messagePl: data?.messagePl,
    });
    // Przerywamy łańcuch — UI zostanie zastąpione przez MaintenanceGate,
    // a żaden kolejny interceptor (np. auth/401-redirect) nie zostanie wywołany.
    return new Promise<never>(() => {});
  }
  return Promise.reject(error);
};
